<sbpro-toast-view class="ngb-toasts" aria-live="polite" aria-atomic="true"></sbpro-toast-view>
<router-outlet></router-outlet>

<app-notice-session-chat-floating-host></app-notice-session-chat-floating-host>

<!-- App nativo (spec 058): cobre o conteúdo quando a casca pede a biometria na volta do segundo plano. -->
<app-native-app-lock></app-native-app-lock>

@if (showCookieBanner) {
	<div class="cookie-consent fixed-bottom">
		<div class="container d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-2">
			<div class="me-md-3">
				<strong>Cookies de sessão</strong>
				<div class="small">
					Usamos cookies de sessão para manter sua autenticação ativa, melhorar sua experiencia e reforçar a segurança. Alguns dados de uso podem ser
					coletados para aprimorar o serviço. Veja nossos
					<a class="link-light text-decoration-underline" [href]="portalUrl + '/terms'" target="_blank">termos</a>
					e a
					<a class="link-light text-decoration-underline" [href]="portalUrl + '/politics'" target="_blank">politica de privacidade</a>
					.
				</div>
			</div>
			<button type="button" class="btn btn-light btn-sm" (click)="acceptCookieConsent()">Aceitar</button>
		</div>
	</div>
}
